import { isObject } from "@atlassiansox/bxp-shared-utils";

import { CSSUnits, isCSSUnits } from "./css-units";

export type PositionType = "keywords" | "units";

export function isPositionType(value: string): value is PositionType {
    return ["keywords", "units"].includes(value);
}

export type PositionHorizontalKeyword = "left" | "center" | "right";

export function isPositionHorizontalKeyword(
    value: string
): value is PositionHorizontalKeyword {
    return ["left", "center", "right"].includes(value);
}

export type PositionVerticalKeyword = "top" | "center" | "bottom";

export function isPositionVerticalKeyword(
    value: string
): value is PositionVerticalKeyword {
    return ["top", "center", "bottom"].includes(value);
}

export type Position = {
    fieldType: PositionType;
    keywords: {
        horizontal: PositionHorizontalKeyword;
        vertical: PositionVerticalKeyword;
    };
    units: {
        horizontal: number;
        vertical: number;
        unit: CSSUnits;
    };
};

export function isPosition(value: unknown): value is Position {
    if (typeof value !== "object" || Array.isArray(value) || value === null) {
        return false;
    }
    const temp = value as Position;

    return (
        isPositionType(temp.fieldType) &&
        isObject(temp.keywords) &&
        isPositionHorizontalKeyword(temp.keywords.horizontal) &&
        isPositionVerticalKeyword(temp.keywords.vertical) &&
        isObject(temp.units) &&
        isCSSUnits(temp.units.unit) &&
        typeof temp.units.horizontal === "number" &&
        typeof temp.units.vertical === "number"
    );
}
